import React, { useEffect, useState } from 'react'
import Netflix_Logo from '../../assets/Netflix_Logo.png';
import NetFlix_avatar from '../../assets/Netflix_Avatar.png';
import './Nav.css';

function Nav() {

    const [show, setShow] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 180) {
                setShow(true)
            } else setShow(false)
        })
        return () => {
            window.removeEventListener("scroll")
        }
    },[])

    return (
        <div className={`nav ${show && 'nav_black'}`}>
            <img className="nav_logo" src={Netflix_Logo} alt="Netflix_Logo" />
             <img className="nav_avatar" src={NetFlix_avatar} alt="User_Netflix" />
        </div>
    )
}

export default Nav
